import classNames from "classnames";
import { EventKey } from "PFTypes/event_key";
import { forwardRef, KeyboardEvent, SyntheticEvent } from "react";

import css from "./divs.module.scss";

export type ActionDivProps = React.PropsWithChildren<
  {
    ariaLabel?: string;
    onClick?: () => void;
    disabled?: boolean;
  } & Omit<React.HTMLAttributes<HTMLDivElement>, "onClick" | "ariaLabel">
>;

export const ActionDiv = forwardRef<HTMLDivElement, ActionDivProps>(
  ({ onClick, children, className, ariaLabel, onKeyDown, disabled, tabIndex = -1, ...divProps }, ref) => {
    const handleClick = (event: SyntheticEvent) => {
      if (!onClick || disabled) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      onClick();
    };

    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
      if (event.key !== EventKey.Enter && event.key !== EventKey.Space) {
        return;
      }

      handleClick(event);
    };

    return (
      <div
        className={classNames(css.actionDiv, { [css.clickable]: !disabled }, className)}
        onClick={handleClick}
        onKeyDown={tabIndex >= 0 ? handleKeyDown : undefined}
        role="button"
        tabIndex={tabIndex}
        aria-label={ariaLabel}
        ref={ref}
        {...divProps}
      >
        {children}
      </div>
    );
  }
);

ActionDiv.displayName = "ActionDiv";
